import { render, staticRenderFns } from "./BxRadio.vue?vue&type=template&id=4a8185b2&"
import script from "./BxRadio.vue?vue&type=script&lang=js&"
export * from "./BxRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports